<template>
  <CoverUploadWidget @saveImage="saveCover($event)"
                     @removeImage="deleteCover()"
                     :image-key="profileCover"/>
  <div class="container container-fixed-992 pb-5">
    <div class="row row-user-avatar">
      <div class="col-12 mb-4">
        <div v-if="uploading" class="user-avatar">
          <div class="img-avatar skeleton imageM"></div>
        </div>
        <AvatarWidget
            v-else
            :image-key="userAvatar.avatar"
            :social-avatar="userAvatar.socialAvatar"
            image-size="imageL"
            :full-name-avatar="userProfile.avatar.fullNameAvatar"
            :alt="userProfile.fullName"
            :title="userProfile.fullName">
        </AvatarWidget>
      </div>
      <div class="col-12">
        <h1 class="user-name">{{ userProfile.fullName }}</h1>
        <div class="buttons vertical-middle">
          <span class="me-1">
              <PhotoUploadWidget @saveImage="saveAvatar($event)"
                                 :image-key="userAvatar.avatar"
                                 image-size="imageL"
                                 button-label="Upload Photo"/>
            </span>
        </div>
      </div>
    </div>
  </div>

</template>
<script lang="ts">
import {defineComponent} from 'vue';
import PhotoUploadWidget from '@shared/components/widgets/photo-upload/photo-upload.widget.vue';
import CoverUploadWidget from '@shared/components/widgets/photo-upload/cover-upload.widget.vue';
import {CommonNs, UserNs} from '@shared/types';
import AvatarWidget from '@shared/components/widgets/profile/avatar.widget.vue';
import {mapStores} from "pinia";
import {useAccountStore} from "@domains/account/stores/account.store";
import {useUserStore} from "@shared/stores/user.store";
import {useGeneralStore} from "@shared/stores/general.store";
import {toast} from '@shared/ms-components'

export default defineComponent({
  name: 'ProfileHeaderCardWidget',
  components: {
    AvatarWidget,
    PhotoUploadWidget,
    CoverUploadWidget,
  },
  data() {
    return {
      uploading: false,
    };
  },
  computed: {
    ...mapStores(useAccountStore, useUserStore, useGeneralStore),
    profileCover(): string {
      return this.accountStore.getProfileCover
    },
    userAvatar(): UserNs.UserAvatar {
      return this.userStore.getUserAvatar;
    },
    userProfile(): UserNs.UserProfile {
      return this.userStore.getUserProfile;
    }
  },
  methods: {
    saveCover(fileData: CommonNs.ImageData) {
      const data = new FormData();
      data.append('file', new File([fileData.file], fileData.name, {type: fileData.type}));

      this.accountStore.uploadProfileCover(data)
          .then(() => {
            this.accountStore.loadAccount().then(() => {
            })

            toast.success('Saved');
          });
    },
    deleteCover() {
      if (this.accountStore.getProfileCover) {
        this.accountStore.removeProfileCover(this.accountStore.getProfileCover)
            .then(() => {
            });
      }
    },
    saveAvatar(fileData: CommonNs.ImageData) {
      if (fileData) {
        document.getElementById('photoUploadButton')?.click();
        this.uploading = true;
        const data = new FormData();
        data.append('file', new File([fileData.file], fileData.name, {type: fileData.type}));

        this.accountStore.uploadProfileAvatar(data)
            .then(() => {
              this.userStore.getUserMe().then(() => {
                this.uploading = false;
              })
                  .catch(() => {
                    this.uploading = false;
                  });

              toast.success('Saved');
            })
            .catch(() => {
              this.uploading = false;
            });
      } else {
        this.removeAvatar();
      }
    },
    removeAvatar() {
      document.getElementById('photoUploadButton')?.click();
      const userAvatar = this.userStore.getUserAvatar;
      if (userAvatar.avatar) {
        this.uploading = true;
        this.accountStore.removeProfileAvatar(userAvatar.avatar)
            .then(() => {
              this.uploading = false;
              this.userStore.getUserMe().then(() => {
                this.uploading = false;
              })
                  .catch(() => {
                    this.uploading = false;
                  });
            }).catch(() => this.uploading = false);
      }
    },
  },
});

</script>
<style lang="scss" scoped>

.buttons {
  .btn {
    margin: var(--space-0);
  }
}

.user-name {
  font-weight: 600;
  margin-bottom: 15px;
}

.user-avatar {
  overflow: hidden;
  width: 140px;
  height: 140px;
  position: relative;
  mask-image: url("data:image/svg+xml,%3Csvg clip-rule='evenodd' fill-rule='evenodd' viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m18.947 18.947c-13.32 13.32-17.947 42.57-17.947 109.053s4.626 95.732 17.947 109.053c13.32 13.32 42.57 17.947 109.053 17.947s95.732-4.626 109.053-17.947c13.32-13.32 17.947-42.57 17.947-109.053s-4.626-95.732-17.947-109.053c-13.32-13.32-42.57-17.947-109.053-17.947s-95.732 4.626-109.053 17.947z' fill-rule='nonzero' stroke='%23000' transform='matrix(.992126 0 0 .992126 1.00787 1.00787)'/%3E%3C/svg%3E");
  mask-position: center center;
  mask-repeat: no-repeat;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  & > img {
    background-color: rgb(244, 244, 245);
    border-radius: $br-xs;
    display: block;
    height: 100%;
    margin: 0px;
    padding: 0px;
    position: relative;
    width: 100%;
    z-index: 0;
  }

  & > .text-avatar {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 140px;
    height: 140px;
    color: var(--text-light);
    background: var(--neutral-200);
    font-size: var(--fs-24);
    font-weight: 700;
    mask-image: url("data:image/svg+xml,%3Csvg clip-rule='evenodd' fill-rule='evenodd' viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m18.947 18.947c-13.32 13.32-17.947 42.57-17.947 109.053s4.626 95.732 17.947 109.053c13.32 13.32 42.57 17.947 109.053 17.947s95.732-4.626 109.053-17.947c13.32-13.32 17.947-42.57 17.947-109.053s-4.626-95.732-17.947-109.053c-13.32-13.32-42.57-17.947-109.053-17.947s-95.732 4.626-109.053 17.947z' fill-rule='nonzero' stroke='%23000' transform='matrix(.992126 0 0 .992126 1.00787 1.00787)'/%3E%3C/svg%3E");
    mask-position: center center;
    mask-repeat: no-repeat;

    h1 {
      color: var(--text-light);
      margin: var(--space-0);
    }
  }
}

.cover {
  width: 100%;
  height: 190px;
  background-color: var(--light-200);
  border-top: 1px dashed var(--neutral-100);
  border-bottom: 1px dashed var(--neutral-100);
}

</style>
